const Postulant = {
    email: '',
    name: '',
    password: '',
    idTipoDocumento: '',
    nroDocumento: '',
    roles:  [
        {
            id: 1,
            nombre: 'Postulante',
            descripcion: 'Postulante'
        }
    ],
}

export default Postulant;